export const customerTierTags = {
  SILVER: 'swell_vip_silver',
  GOLD: 'swell_vip_gold',
  PLATINUM: 'swell_vip_platinum',
}

export const customerTierLabels = {
  SILVER: 'Silver',
  GOLD: 'Gold',
  PLATINUM: 'Platinum',
}

export const defaultTag = 'customer_without_tier_tag'
